import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DraggableAccordion } from "./drag-n-drop/draggableAccordion";
import filterIcon from "../images/filterIcon.png";
import axios from "axios";
import SearchInputField from "./SearchInputField";
import EditInputField from "./EditInputField";
import AssociatedContact from "./AssociatedContact";
import { IoIosContacts } from "react-icons/io";
import { MdModeEdit } from "react-icons/md";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { TbFilterPin } from "react-icons/tb";
import { FiDownload, FiTrash2 } from "react-icons/fi";
import TagInput from "./TagInput";
import TableSkeleton from "./TableSkeleton";
import Select from "react-select";
import toast from "react-hot-toast";
import ButtonLoader from "./ButtonLoader";
import { getStoredRole } from "../constants/roles";
import useTeamOptions from "../Hooks/useTeamOptions";
import ConfigurableFilterFields from "./ConfigurableFilterFields";
import {
  CANVASSING_LANGUAGE_BARRIER_OPTIONS,
  IncomeSTHHOption,
} from "../constants";
import { useTheme } from "../context/ThemeContext";
import { getDispositionColor, getDispositionOptions } from "../utils/dispositionColors";
import {
  createDatabase,
  storeDataInIndexedDB,
  fetchDataFromIndexedDB,
  deleteDataFromIndexedDB,
  updateDataInIndexedDB,
} from "../Hooks/IndexedDBUtils";
import { syncableTracking } from "./CanvassMap";
import { parseDate, parseDateFromMilliseconds, showApiError } from "../utils";
import { getCursorState, getFilteredOffset } from "../utils/householdCursor";
import { streetNameMatches } from "../utils/streetMatch";
import { canSortLocally, sortRows } from "../utils/sortRows";
import {
  useOnlineStatus,
  saveHouseholdSnapshot,
  loadHouseholdSnapshot,
  clearHouseholdSnapshot,
  saveHouseholdContactsSnapshot,
  loadHouseholdContactsSnapshot,
  saveCityOptions,
  loadCityOptions as loadCachedCityOptions,
  saveDataProperties,
  loadDataProperties,
  saveUserList,
  loadUserList,
} from "../Hooks/useOfflineHousehold";

const { REACT_APP_BASE_URL } = process.env;

const householdListDB = createDatabase("householdListDB", "householdListStore");

const HouseholdsComponent = () => {
  const token = localStorage.getItem("token");
  const userMail = localStorage.getItem("urserMail");
  const userRole = getStoredRole();
  const ownerID = localStorage.getItem("ownerId");

  const dispositionColors = useTheme()?.theme?.dispositionColors;
  const limit = 100;
  const online = useOnlineStatus();
  const [dataList, setDataList] = useState([]);
  const [cachedDataList, setCachedDataList] = useState([]);
  const [dataSource, setDataSource] = useState("online");
  const [isSavingOffline, setIsSavingOffline] = useState(false);
  const [hasOfflineSnapshot, setHasOfflineSnapshot] = useState(false);
  const [loading, setLoading] = useState(true);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [hideLoading, setHideLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [page, setPage] = useState(1);
  const nextOffsetRef = useRef(null);
  const requestIdRef = useRef(0);
  const [allCityOptions, setAllCityOptions] = useState([]);

  // filters
  const { teamOptions } = useTeamOptions();
  const [searchTeam, setSearchTeam] = useState("");
  const [searchAddress, setSearchAddress] = useState([]);
  const [searchCity, setSearchCity] = useState("");
  const [searchCityTags, setSearchCityTags] = useState([]);
  const [searchZip, setSearchZip] = useState("");
  const [customFilterValues, setCustomFilterValues] = useState({});
  const [searchCensus_block, setSearchCensus_block] = useState("");
  const [searchPresence_of_children_code, setSearchpresence_of_children_code] =
    useState("");
  const [listMemberData, setListMemberData] = useState([]);
  const [selectedMemberList, setSelectedMemberList] = useState("");

  // sort
  const [sortData, setSortData] = useState(null);
  const [isAddressAscending, setIsAddressAscending] = useState(true);
  const [isCityAscending, setIsCityAscending] = useState(true);
  const [isApartmentAscending, setIsApartmentAscending] = useState(true);

  // filter payload
  const [filterPayload, setFilterPayload] = useState(null);

  // checkbox / assign
  const [checkedItems, setCheckedItems] = useState([]);
  const [isAllCheckActive, setAllCheckActive] = useState(false);
  const [active, setActive] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ id: "", email: "" });
  const [selectedUser2, setSelectedUser2] = useState({ id: "", email: "" });
  const [assignError, setAssignError] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const checkedItemListRef = useRef([]);

  // edit modal state
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [userId, setUserId] = useState("");
  // Property visibility (see docs/implementation-plans/2026-09-15-property-visibility-survey-groups.md)
  // only governs the edit modal - the table always shows real values. The
  // backend sends full properties plus a `hidden_fields` list on the list
  // response; this tracks the most recently seen list so the modal can skip
  // rendering those fields when it opens.
  const [hiddenFields, setHiddenFields] = useState([]);
  const [visiblePropertyKeys, setVisiblePropertyKeys] = useState(null);
  // Same idea as hiddenFields above, but for the tenant's Contact visibility
  // settings, used by the Associated Contacts modal (household record's
  // linked contacts) rather than the household record itself.
  const [contactHiddenFields, setContactHiddenFields] = useState([]);
  const [l2Id, setL2Id] = useState(null);
  const [canvasser_email, setCanvasser_email] = useState("");
  const [coordinate_latitude, setCoordinate_latitude] = useState("");
  const [coordinate_longitude, setCoordinate_longitude] = useState("");
  const [mailing_address_line, setMailing_address_line] = useState("");
  const [mailing_adress_zip, setMailing_adress_zip] = useState("");
  const [mailing_city, setMailing_city] = useState("");
  const [presence_of_children_code, setPresence_of_children_code] =
    useState("");
  const [
    residence_household_gender_composition,
    setResidence_household_gender_composition,
  ] = useState("");
  const [residence_state, setResidence_state] = useState("");
  const [residence_zip, setResidence_zip] = useState("");
  const [houseHoldDisposition, setHouseHoldDisposition] = useState("");
  const [canvassingLanguageBarrier, setCanvassingLanguageBarrier] =
    useState("");
  const [
    residence_families_count_of_voters_in_household,
    setResidence_families_count_of_voters_in_household,
  ] = useState("");
  const [incomesthh, setIncomeSTHH] = useState("");
  const [last_door_knocked, set_last_door_knocked] = useState("");
  const [last_door_knocked_by, set_last_door_knocked_by] = useState("");
  const [attempt_tracker, set_attempt_tracker] = useState("");
  const [household_attempted_, set_household_attempted_] = useState("");

  // associated contacts
  const [associatedContact, setAssociatedContact] = useState({});
  const [showAssociateList, setShowAssociateList] = useState(false);
  const [isAssociateListLoading, setIsAssociateListLoading] = useState(false);

  // supporting data
  const [dataProperty, setDataproperty] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [userList, setUserList] = useState([]);

  // ─── Data fetching ────────────────────────────────────────────────────────

  const buildBasePayload = (
    pageNumber,
    sort = sortData,
    fp = filterPayload,
    key = null,
  ) => {
    let data = {};
    const offset = getFilteredOffset(pageNumber, nextOffsetRef.current, limit);
    if (fp && key !== "RESET") {
      data = { ...fp, offset, limit };
    } else if (userRole === "ROLE_REGIONAL_MANAGER") {
      data = {
        search_city: searchCity || null,
        offset,
        limit,
      };
    } else {
      data = { email: userMail, offset, limit };
    }
    if (sort) {
      data = {
        ...data,
        sort_by: sort.sortBy,
        direction: sort.direction.toUpperCase(),
      };
    }
    return {
      ...data,
      ...(userRole === "ROLE_REGIONAL_MANAGER" ? { role: userRole } : ""),
    };
  };

  const fetchHouseholds = async (customPage = null, key = null) => {
    setLoading(true);
    const pageNumber = customPage || page;

    if (key === "RESET") {
      nextOffsetRef.current = null;
      setDataList([]);
      checkedItemListRef.current = [];
      setCheckedItems([]);
      deleteDataFromIndexedDB(householdListDB, "householdListStore");
    }

    try {
      const res = await axios.post(
        `${REACT_APP_BASE_URL}/householdListAll`,
        buildBasePayload(
          pageNumber,
          sortData,
          key === "RESET" ? null : filterPayload,
          key,
        ),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const newData = res.data.results;
      const { hasCursor, nextOffset, exhausted } = getCursorState(res.data, newData.length);
      nextOffsetRef.current = nextOffset;
      setTotalRecord(res.data.total);
      setHiddenFields(res.data.hidden_fields || []);
      if (newData.length === 0) {
        setAllDataLoaded(hasCursor ? exhausted : true);
      } else {
        const combined = customPage
          ? newData
          : [...checkedItemListRef.current, ...newData];
        checkedItemListRef.current = combined;
        setDataList(combined);
        storeDataInIndexedDB(householdListDB, "householdListStore", combined);
        setAllDataLoaded(hasCursor ? exhausted : newData.length < limit);
      }
      setPage(pageNumber + 1);
    } catch (error) {
      if (error.response) {
        showApiError(error, "Failed to load households");
      } else if (customPage) {
        // No response object means the request never reached the server.
        // navigator.onLine only reflects the network interface being up, not
        // real internet connectivity, so the mount effect's "if (navigator.
        // onLine)" branch can still run and fail here even though there's no
        // actual connection. Fall back to the explicit "Download" snapshot
        // only - never householdListDB, which auto-caches whatever was last
        // viewed online (filtered or not) regardless of whether the user ever
        // pressed Download. Surfacing that here would silently show data the
        // user never chose to save for offline.
        const snapshot = await loadHouseholdSnapshot();
        setCachedDataList(Array.isArray(snapshot) ? snapshot : []);
        setDataSource("cached");
      }
    } finally {
      setLoading(false);
      setHideLoading(false);
    }
  };

  const getCityOptions = async () => {
    try {
      const response = await axios.get(`${REACT_APP_BASE_URL}/getCity`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data) {
        const options = response.data.cities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setAllCityOptions(options);
        saveCityOptions(options);
      }
    } catch (error) {
      console.error("Error fetching city data:", error);
    }
  };

  const DatabaseProperty = async () => {
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/databaseProperties`,
        "",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data) {
        setDataproperty(response.data);
        saveDataProperties(response.data);
      }
    } catch (error) {
      console.error("Error fetching database properties:", error);
    }
  };

  const fetchOwnerList = async () => {
    try {
      const response = await axios.get(`${REACT_APP_BASE_URL}/ownerlist`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const newData = response.data.results;
      setOwnerList(newData);
      setUserList(newData);
      saveUserList(newData);
    } catch (error) {
      console.error("Error fetching owner list:", error);
    }
  };

  const getListMemberShipList = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_BASE_URL}/list_membership_contact`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setListMemberData(res?.data?.options);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetchHouseholds(1);
      getCityOptions();
      DatabaseProperty();
      fetchOwnerList();
      getListMemberShipList();
    }
    // The offline case is handled by the [online] effect below, which also
    // runs on mount - keeping a second, separate IndexedDB read here just
    // races the same work and doesn't set dataSource, so cached rows never
    // rendered even though data was fetched.

    // Whether a "Download" snapshot exists is independent of current
    // connectivity - check it regardless so "Clear cached data" can be shown
    // any time there's something to clear, not only while offline.
    loadHouseholdSnapshot().then((data) => {
      setHasOfflineSnapshot(Array.isArray(data) && data.length > 0);
    });
  }, []);

  // React to connectivity changes: switch to the saved offline snapshot when
  // the connection drops, and back to live data (untouched) when it returns.
  useEffect(() => {
    if (!online) {
      // Only ever show what the user explicitly saved via "Download" -
      // householdListDB is a separate, pre-existing auto-cache that silently
      // stores whatever page/filter was last viewed online, regardless of
      // whether Download was ever pressed. Falling back to it here would show
      // data the user never chose to save for offline (e.g. an unfiltered
      // view browsed after downloading a filtered one).
      loadHouseholdSnapshot().then((data) => {
        setCachedDataList(Array.isArray(data) ? data : []);
        setDataSource("cached");
        setLoading(false);
      });
      // The city filter dropdown otherwise stays empty offline since
      // getCityOptions() only ever runs while online.
      loadCachedCityOptions().then((options) => {
        if (Array.isArray(options) && options.length > 0)
          setAllCityOptions(options);
      });
      // Same gap for the presence_of_children_code / gender_composition
      // dropdowns - DatabaseProperty() only ever runs while online.
      loadDataProperties().then((properties) => {
        if (Array.isArray(properties) && properties.length > 0)
          setDataproperty(properties);
      });
      // Same gap for the "last door knocked by" owner/user dropdown -
      // fetchOwnerList() only ever runs while online.
      loadUserList().then((users) => {
        if (Array.isArray(users) && users.length > 0) {
          setOwnerList(users);
          setUserList(users);
        }
      });
    } else {
      setDataSource("online");
    }
  }, [online]);

  useEffect(() => {
    const handleSyncCompleted = () => {
      if (navigator.onLine) {
        fetchHouseholds(1, "RESET");
      }
    };

    window.addEventListener("syncCompleted", handleSyncCompleted);
    return () => window.removeEventListener("syncCompleted", handleSyncCompleted);
  }, []);

  const handleSaveOffline = async () => {
    setIsSavingOffline(true);
    try {
      await saveHouseholdSnapshot(dataList);
      setHasOfflineSnapshot(true);
      toast.success("Household data saved for offline use");
    } catch (error) {
      console.error("Error saving offline snapshot:", error);
      toast.error("Failed to save offline data");
    } finally {
      setIsSavingOffline(false);
    }
  };

  const handleClearCachedData = async () => {
    await clearHouseholdSnapshot();
    setHasOfflineSnapshot(false);
    setCachedDataList([]);
    toast.success("Cached data cleared");
  };

  // ─── Cached-mode client-side filter & sort ────────────────────────────────

  const matchesCachedFilters = (ele) => {
    const props = ele?.properties || {};
    const address = (
      props.residence_address_line ||
      props.aristotle_address ||
      ""
    ).toLowerCase();
    const city = (
      props.residence_city ||
      props.aristotle_city ||
      props.mailing_city ||
      ""
    ).toLowerCase();
    const zip = (props.residence_zip || "").toLowerCase();
    const censusBlock = (props.census_block || "").toLowerCase();
    const childrenCode = (props.presence_of_children_code || "").toLowerCase();

    if (
      searchAddress?.length > 0 &&
      !searchAddress.some((v) => streetNameMatches(String(v), address))
    )
      return false;
    if (
      searchCityTags?.length > 0 &&
      !searchCityTags.some((v) => address.includes(String(v).toLowerCase()))
    )
      return false;
    if (searchCity && !city.includes(searchCity.toLowerCase())) return false;
    if (searchZip && !zip.includes(searchZip.toLowerCase())) return false;
    if (
      searchCensus_block &&
      !censusBlock.includes(searchCensus_block.toLowerCase())
    )
      return false;
    if (
      searchPresence_of_children_code &&
      childrenCode !== searchPresence_of_children_code.toLowerCase()
    )
      return false;
    return true;
  };

  const getCachedSortValue = (ele, field) => {
    const props = ele?.properties || {};
    if (field === "residence_address_line")
      return props.residence_address_line || props.aristotle_address || "";
    if (field === "mailing_city")
      return (
        props.mailing_city || props.residence_city || props.aristotle_city || ""
      );
    if (field === "apt_number") return props.apt_number || "";
    return "";
  };

  const cachedDisplayList = React.useMemo(() => {
    let list = cachedDataList.filter(matchesCachedFilters);
    if (sortData) {
      const field = sortData.sortBy;
      const dir = sortData.direction === "ascending" ? 1 : -1;
      list = [...list].sort(
        (a, b) =>
          String(getCachedSortValue(a, field)).localeCompare(
            String(getCachedSortValue(b, field)),
          ) * dir,
      );
    }
    return list;
  }, [
    cachedDataList,
    sortData,
    searchAddress,
    searchCityTags,
    searchCity,
    searchZip,
    searchCensus_block,
    searchPresence_of_children_code,
  ]);

  // ─── Filters ─────────────────────────────────────────────────────────────

  const applyFilters = async (e) => {
    e.preventDefault();
    if (dataSource === "cached") {
      // Cached mode filters entirely client-side via matchesCachedFilters /
      // cachedDisplayList — no server round-trip since there's no network.
      return;
    }
    const payload = {
      ...(userRole === "ROLE_REGIONAL_MANAGER"
        ? { search_city: searchCity || null, role: userRole }
        : { email: userMail }),
      ...(() => {
        const mergedAddresses = Array.from(
          new Set([...(searchCityTags || []), ...(searchAddress || [])].filter(Boolean))
        );
        return mergedAddresses.length > 0
          ? { residence_address_line: mergedAddresses }
          : searchCity
            ? { search_city: searchCity }
            : {};
      })(),
      ...(searchZip ? { residence_zip: searchZip } : {}),
      ...(searchCensus_block ? { census_block: searchCensus_block } : {}),
      ...(searchPresence_of_children_code
        ? { presence_of_children_code: searchPresence_of_children_code }
        : {}),
      ...(Object.values(customFilterValues).some(Boolean) ? { custom_filters: customFilterValues } : {}),
      ...(selectedMemberList ? { list_membership: selectedMemberList } : {}),
      ...(searchTeam ? { team_id: searchTeam } : {}),
    };
    setFilterPayload(payload);
    setPage(1);
    nextOffsetRef.current = null;
    requestIdRef.current += 1;
    setDataList([]);
    checkedItemListRef.current = [];
    setCheckedItems([]);
    setAllCheckActive(false);
    setActive(false);
    deleteDataFromIndexedDB(householdListDB, "householdListStore");
    setLoading(true);
    try {
      const res = await axios.post(
        `${REACT_APP_BASE_URL}/householdListAll`,
        { ...payload, offset: 0, limit, owner_id: ownerID },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const newData = res.data.results;
      const { hasCursor, nextOffset, exhausted } = getCursorState(res.data, newData.length);
      nextOffsetRef.current = nextOffset;
      setTotalRecord(res.data.total);
      setHiddenFields(res.data.hidden_fields || []);
      checkedItemListRef.current = newData;
      setDataList(newData);
      setAllDataLoaded(hasCursor ? exhausted : newData.length < limit);
      setPage(2);
      storeDataInIndexedDB(householdListDB, "householdListStore", newData);
    } catch (error) {
      console.error("Filter error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilterPayload(null);
    setSortData(null);

    setSearchAddress([]);
    setSearchTeam("");
    setSearchCity("");
    setSearchCityTags([]);
    setSearchZip("");
    setSearchCensus_block("");
    setSearchpresence_of_children_code("");
    setCustomFilterValues({});
    setSelectedMemberList("");
    setCheckedItems([]);
    setAllCheckActive(false);
    setActive(false);

    if (dataSource === "cached") {
      // No network available in cached mode - just clear the active
      // filter/sort state so cachedDisplayList shows the full snapshot again.
      return;
    }
    setPage(1);
    setDataList([]);
    checkedItemListRef.current = [];
    deleteDataFromIndexedDB(householdListDB, "householdListStore");
    fetchHouseholds(1, "RESET");
  };

  const handlePagination = () => {
    if (!loading && !allDataLoaded) fetchHouseholds();
  };

  // ─── Sorting ──────────────────────────────────────────────────────────────

  const sortHouseholds = async (sortBy, direction) => {
    const newSortData = { sortBy, direction };
    setSortData(newSortData);

    if (canSortLocally(allDataLoaded, checkedItemListRef.current)) {
      requestIdRef.current += 1;
      const sorted = sortRows(
        checkedItemListRef.current,
        (row) => getCachedSortValue(row, sortBy),
        direction,
      );
      checkedItemListRef.current = sorted;
      setDataList(sorted);
      storeDataInIndexedDB(householdListDB, "householdListStore", sorted);
      return;
    }

    nextOffsetRef.current = null;
    const reqId = ++requestIdRef.current;
    setLoading(true);
    try {
      const res = await axios.post(
        `${REACT_APP_BASE_URL}/householdListAll`,
        {
          ...buildBasePayload(1, newSortData, filterPayload, null),
          owner_id: ownerID,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (reqId !== requestIdRef.current) return;
      const newData = res.data.results;
      const { hasCursor, nextOffset, exhausted } = getCursorState(res.data, newData.length);
      nextOffsetRef.current = nextOffset;
      checkedItemListRef.current = newData;
      setDataList(newData);
      storeDataInIndexedDB(householdListDB, "householdListStore", newData);
      setTotalRecord(res.data.total);
      setHiddenFields(res.data.hidden_fields || []);
      setAllDataLoaded(hasCursor ? exhausted : newData.length < limit);
      setPage(2);
    } catch (error) {
      console.error("Sort error:", error);
    } finally {
      if (reqId === requestIdRef.current) setLoading(false);
    }
  };

  const toggleAddressSortingOrder = () => {
    const next = !isAddressAscending;
    setIsAddressAscending(next);
    if (dataSource === "cached") {
      setSortData({
        sortBy: "residence_address_line",
        direction: next ? "ascending" : "descending",
      });
    } else {
      sortHouseholds(
        "residence_address_line",
        next ? "ascending" : "descending",
      );
    }
  };

  const toggleCitySortingOrder = () => {
    const next = !isCityAscending;
    setIsCityAscending(next);
    if (dataSource === "cached") {
      setSortData({
        sortBy: "mailing_city",
        direction: next ? "ascending" : "descending",
      });
    } else {
      sortHouseholds("mailing_city", next ? "ascending" : "descending");
    }
  };

  const toggleApartmentSortingOrder = () => {
    const next = !isApartmentAscending;
    setIsApartmentAscending(next);
    if (dataSource === "cached") {
      setSortData({
        sortBy: "apt_number",
        direction: next ? "ascending" : "descending",
      });
    } else {
      sortHouseholds("apt_number", next ? "ascending" : "descending");
    }
  };

  // ─── Checkbox / Assign ────────────────────────────────────────────────────

  const handleCheckedItem = (id) => {
    const idx = checkedItems.indexOf(id);
    const newChecked = [...checkedItems];
    if (idx === -1) newChecked.push(id);
    else newChecked.splice(idx, 1);
    setCheckedItems(newChecked);
    // Manual per-row checking must never turn select-all ON (that's
    // handleCheckedAll's job exclusively), but if select-all was already ON
    // and this uncheck breaks the fully-selected set, turn it back OFF so a
    // partial selection can't be submitted as all_households: true.
    if (
      isAllCheckActive &&
      newChecked.length < checkedItemListRef.current.length
    ) {
      setAllCheckActive(false);
    }
  };

  const handleCheckedAll = () => {
    const next = !isAllCheckActive;
    setAllCheckActive(next);
    // Only auto-promote to the full "select all matching" mode when a real
    // filter is applied and every record it matches is already loaded (no
    // more pages left) - then checking every loaded row already IS selecting
    // every matching household. Without a filter, always fall back to the
    // scoped household_ids path, since the backend refuses an all_households
    // request that has no real filter behind it.
    setActive(next && allDataLoaded && !!filterPayload);
    setCheckedItems(next ? checkedItemListRef.current.map((d) => d.id) : []);
  };
  const handleClick = () => {
    if (active) {
      setAllCheckActive(false);
    }
    setActive(!active);
    const newCheckedItems = active ? [] : dataList.map((data) => data.id);
    setCheckedItems(newCheckedItems);
  };

  const handleUserSelect = (e) => {
    const selectedIndex = e.target.selectedIndex;
    setSelectedUser({
      id: e.target.options[selectedIndex].getAttribute("data-id"),
      email: e.target.value,
    });
    setAssignError(false);
  };

  const handleUser2Select = (e) => {
    const selectedIndex = e.target.selectedIndex;
    setSelectedUser2({
      id: e.target.options[selectedIndex].getAttribute("data-id"),
      email: e.target.value,
    });
    setAssignError(false);
  };

  const handleAssignedSubmit = async (e) => {
    e.preventDefault();

    if (selectedUser.email === "" && selectedUser2.email === "") {
      setAssignError(true);
      return;
    }

    setAssignLoading(true);

    // Close modal immediately and notify user assignment has started
    if (window.HSOverlay) {
      window.HSOverlay.close(
        document.getElementById("hs-household-assign-modal"),
      );
    }
    toast.success("Canvasser assignment started...");

    let data;
    // `active` is the explicit "Select all {totalRecord} records" banner
    // action (handleClick) - the only real signal for "assign every matching
    // household". `isAllCheckActive` just means the header checkbox has
    // checked the currently loaded rows and must NOT trigger a mass update.
    if (active && !filterPayload) {
      data = {
        assoc_to_email: selectedUser.email || selectedUser2.email,
        tcp_assoc_to_id: selectedUser2.id || "",
        assoc_to_id: selectedUser.id || "",
        all_households: true || "",
        last_filtered: {
          mailing_address_line: "",
          mailing_city: "",
          residence_zip: "",
          census_block: "",
          presence_of_children_code: "",
          household_disposition: "",
          canvassing_language_barrier: "",
        },
      };
    } else if (active && filterPayload) {
      data = {
        assoc_to_email: selectedUser.email || selectedUser2.email,
        tcp_assoc_to_id: selectedUser2.id || "",
        assoc_to_id: selectedUser.id || "",
        all_households: true || "",
        last_filtered: filterPayload || "",
      };
    } else {
      data = {
        assoc_to_email: selectedUser.email || selectedUser2.email,
        tcp_assoc_to_id: selectedUser2.id,
        assoc_to_id: selectedUser.id,
        household_ids: checkedItems,
        all_households: false,
      };
    }

    try {
      const res = await axios.post(
        `${REACT_APP_BASE_URL}/assoc_user_household`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.data) {
        await new Promise((resolve) => setTimeout(resolve, 3000));
        toast.success(
          typeof res.data === "string"
            ? res.data
            : "Households assigned successfully",
        );
        setCheckedItems([]);
        setAllCheckActive(false);
        setActive(false);
        fetchHouseholds(1, "RESET");
      }
    } catch (error) {
      console.error("Error Household Assigned:", error);
      toast.error("Error assigning households");
    } finally {
      setAssignLoading(false);
    }
  };

  // ─── Edit modal ───────────────────────────────────────────────────────────

  const handleEditClick = (user) => {
    setUserId(user?.id);
    const allKeys = Object.keys(user?.properties || {});
    setVisiblePropertyKeys(new Set(allKeys.filter((key) => !hiddenFields.includes(key))));
    setL2Id(user?.properties?.l2_household_id);
    setCanvasser_email(user?.properties?.canvasser_email || "");
    setCoordinate_latitude(
      user?.properties?.coordinate_latitude ||
        user?.properties?.latitude_numeric ||
        "",
    );
    setCoordinate_longitude(
      user?.properties?.coordinate_longitude ||
        user?.properties?.longitude_numeric ||
        "",
    );
    setMailing_address_line(user?.properties?.mailing_address_line || "");
    setMailing_adress_zip(user?.properties?.mailing_adress_zip || "");
    setMailing_city(user?.properties?.mailing_city || "");
    setPresence_of_children_code(
      user?.properties?.presence_of_children_code || "",
    );
    setResidence_household_gender_composition(
      user?.properties?.residence_household_gender_composition || "",
    );
    setResidence_state(user?.properties?.residence_state || "");
    setResidence_zip(user?.properties?.residence_zip || "");
    setHouseHoldDisposition(user?.properties?.household_disposition || "");
    setCanvassingLanguageBarrier(
      user?.properties?.canvassing_language_barrier || "",
    );
    setResidence_families_count_of_voters_in_household(
      user?.properties?.residence_families_count_of_voters_in_household || "",
    );
    setIncomeSTHH(user?.properties?.incomesthh || "");
    set_last_door_knocked(
      parseDateFromMilliseconds(user?.properties?.last_door_knocked),
    );
    set_last_door_knocked_by(user?.properties?.last_door_knocked_by || "");
    set_attempt_tracker(user?.properties?.attempt_tracker || "");
    set_household_attempted_(user?.properties?.household_attempted_ || "");
    setModalIsOpen(true);
  };

  const closeModal = (e) => {
    if (e) e.preventDefault();
    setModalIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    try {
      const data = {
        id: userId,
        l2_household_id: l2Id || "",
        canvasser_email: canvasser_email || "",
        coordinate_latitude: coordinate_latitude !== "" ? coordinate_latitude : "",
        coordinate_longitude: coordinate_longitude !== "" ? coordinate_longitude : "",
        mailing_address_line: mailing_address_line || "",
        mailing_adress_zip: mailing_adress_zip || "",
        mailing_city: mailing_city || "",
        presence_of_children_code: presence_of_children_code || "",
        residence_household_gender_composition:
          residence_household_gender_composition || "",
        residence_state: residence_state || "",
        residence_zip: residence_zip || "",
        household_disposition: houseHoldDisposition || "",
        canvassing_language_barrier: canvassingLanguageBarrier || "",
        incomesthh: incomesthh || "",
        residence_families_count_of_voters_in_household:
          residence_families_count_of_voters_in_household || "",
        attempt_tracker: attempt_tracker || "",
        ...(last_door_knocked
          ? { last_door_knocked: parseDate(last_door_knocked) }
          : { last_door_knocked: parseDate(new Date().toISOString()) }),
        last_door_knocked_by: last_door_knocked_by || ownerID,
        household_attempted_: household_attempted_ || "",
      };

      if (navigator.onLine === false) {
        const storedSyncableTracking = await fetchDataFromIndexedDB(
          syncableTracking,
          "syncableTrackingStore",
        );
        const existingQueued = (storedSyncableTracking || []).find(
          (entry) => entry.id === data.id,
        );
        const updatedIndexData = {
          id: data.id,
          properties: { ...(existingQueued?.properties || {}), ...data },
        };
        delete updatedIndexData.properties.id;
        storeDataInIndexedDB(syncableTracking, "syncableTrackingStore", [
          ...(storedSyncableTracking || []).filter((entry) => entry.id !== data.id),
          updatedIndexData,
        ]);
        updateDataInIndexedDB(
          householdListDB,
          "householdListStore",
          data.id,
          updatedIndexData,
        );
        closeModal();
        toast.success("Household offline updated successfully!");
      } else {
        const res = await axios.put(
          `${REACT_APP_BASE_URL}/householdList`,
          { ...data, owner_id: ownerID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (res.data) {
          toast.success("Household updated successfully!");
          closeModal();
          setCheckedItems([]);
          setAllCheckActive(false);
          fetchHouseholds(1, "RESET");
        }
      }
    } catch (error) {
      // Previously this only console.log'd - if the PUT failed (HubSpot
      // rejected a property value, auth expired, 500, etc.) the user saw
      // neither a success nor an error toast, so the save looked like it
      // silently did nothing.
      console.log("Error:", error);
      showApiError(error, "Failed to update household");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleHouseholdAttempt = async (e) => {
    set_household_attempted_(e.target.checked ? "true" : "false");
    if (!e.target.checked) return;
    if (!userId) return;

    const data = {
      id: userId,
      owner_id: ownerID,
      household_attempted_: "true",
      ...(last_door_knocked
        ? { last_door_knocked: parseDate(last_door_knocked) }
        : { last_door_knocked: parseDate(new Date().toISOString()) }),
      last_door_knocked_by: last_door_knocked_by || ownerID,
    };

    try {
      if (navigator.onLine === false) {
        // Previously this always attempted a live PUT with no offline path,
        // unlike handleSubmit's full edit - queue it the same way so an
        // attempt marked offline isn't silently lost/failed.
        const storedSyncableTracking = await fetchDataFromIndexedDB(
          syncableTracking,
          "syncableTrackingStore",
        );
        const existingQueued = (storedSyncableTracking || []).find(
          (entry) => entry.id === data.id,
        );
        const updatedIndexData = {
          id: data.id,
          properties: { ...(existingQueued?.properties || {}), ...data },
        };
        delete updatedIndexData.properties.id;
        storeDataInIndexedDB(syncableTracking, "syncableTrackingStore", [
          ...(storedSyncableTracking || []).filter((entry) => entry.id !== data.id),
          updatedIndexData,
        ]);
        updateDataInIndexedDB(
          householdListDB,
          "householdListStore",
          data.id,
          updatedIndexData,
        );
        toast.success("Household attempt saved offline!");
      } else {
        await axios.put(`${REACT_APP_BASE_URL}/householdList`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        // This PUT succeeds fine (HubSpot returns the updated object), but
        // nothing here ever told the user that - no success toast at all,
        // so a click that actually worked looked like it silently did
        // nothing.
        toast.success("Household attempted !");
      }
    } catch (error) {
      console.log(error);
      showApiError(error, "Failed to update household attempt");
    }
  };

  const allHouseholdAccordionFields = [
    {
      name: "mailing_address_line",
      label: "Mailing Address Line",
      type: "text",
      accordion: 1,
    },
    {
      name: "mailing_adress_zip",
      label: "Mailing Address Zip",
      type: "text",
      accordion: 1,
    },
    { name: "mailing_city", label: "Mailing City", type: "text", accordion: 1 },
    {
      name: "presence_of_children_code",
      label: "Presence Of Children Code",
      accordion: 1,
    },
    {
      name: "residence_household_gender_composition",
      label: "Residence Household Gender Composition",
      accordion: 1,
    },
    {
      name: "residence_state",
      label: "Residence State",
      type: "text",
      accordion: 1,
    },
    {
      name: "residence_zip",
      label: "Residence Zip",
      type: "text",
      accordion: 1,
    },
    {
      name: "residence_families_count_of_voters_in_household",
      label: "Number of Registered Voters",
      type: "number",
      accordion: 1,
    },
    { name: "incomesthh", label: "Household Income", accordion: 1 },
  ];

  const householdAccordionFields = visiblePropertyKeys
    ? allHouseholdAccordionFields.filter((field) => visiblePropertyKeys.has(field.name))
    : allHouseholdAccordionFields;

  const householdAccordionData = [
    {
      id: 1,
      title: "Additional Information",
      content: householdAccordionFields,
    },
  ];

  const householdAccordionFormState = {
    mailing_address_line,
    mailing_adress_zip,
    mailing_city,
    presence_of_children_code,
    residence_household_gender_composition,
    residence_state,
    residence_zip,
    residence_families_count_of_voters_in_household,
    incomesthh,
  };

  const handleAccordionInputChange = (e) => {
    const { name, value } = e.target;
    const setterMap = {
      mailing_address_line: setMailing_address_line,
      mailing_adress_zip: setMailing_adress_zip,
      mailing_city: setMailing_city,
      presence_of_children_code: setPresence_of_children_code,
      residence_household_gender_composition:
        setResidence_household_gender_composition,
      residence_state: setResidence_state,
      residence_zip: setResidence_zip,
      residence_families_count_of_voters_in_household:
        setResidence_families_count_of_voters_in_household,
      incomesthh: setIncomeSTHH,
    };
    if (setterMap[name]) setterMap[name](value);
  };

  const showAssociateContact = async (id) => {
    if (!id) return;
    setIsAssociateListLoading(true);
    setShowAssociateList((prev) => !prev);

    if (dataSource === "cached" && !navigator.onLine) {
      const cachedContacts = await loadHouseholdContactsSnapshot(id);
      setAssociatedContact((prev) => ({ ...prev, [id]: cachedContacts || [] }));
      setIsAssociateListLoading(false);
      if (!cachedContacts)
        toast.error("Contacts not available offline for this household");
      return;
    }

    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/householdDatabase`,
        { householdID: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setAssociatedContact((prev) => ({
        ...prev,
        [id]: response.data.results,
      }));
      setContactHiddenFields(response.data.hidden_fields || []);
      // Lazily cache contacts the first time they're viewed while online, so
      // they're available if the user goes offline before saving a full
      // snapshot again - bounded to households actually opened, not all of them.
      saveHouseholdContactsSnapshot(id, response.data.results);
    } catch (error) {
      console.error("Error fetching associated contacts:", error);
    } finally {
      setIsAssociateListLoading(false);
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <div>
      {/* Header */}
      <div className="flex justify-between flex-wrap items-center bg-canvas-white py-3 sticky top-[54px] z-10">
        <div className="flex items-center gap-8 pl-5">
          <div className="py-2 flex gap-3 items-center cursor-pointer uppercase border-b-2 border-canvas-primary text-canvas-primary">
            <h6 className="font-semibold">Households</h6>(
            {dataSource === "cached" ? cachedDisplayList.length : totalRecord})
            {dataSource === "cached" && (
              <span className="normal-case text-xs font-normal text-canvas-secondery">
                (offline / cached)
              </span>
            )}
          </div>
          {dataList.length > 0 && checkedItems.length >= 1 && (
            <div className="pl-4">
              <button
                type="button"
                data-hs-overlay="#hs-household-assign-modal"
                className="py-2 px-3 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white disabled:cursor-progress"
              >
                Assign Canvasser
              </button>
            </div>
          )}
        </div>
        <div className="flex gap-2 xs:gap-3 sm:gap-5 items-center pr-5 flex-wrap justify-end">
          <button
            type="button"
            data-hs-overlay="#hs-household-filter-modal"
            className="shrink-0"
          >
            <img className="w-5 h-5" src={filterIcon} alt="filterIcon" />
          </button>
          <button
            type="button"
            data-hs-overlay="#hs-household-city-modal"
            className="shrink-0"
          >
            <TbFilterPin className="w-5 h-5" />
          </button>
          <button
            className="p-1.5 sm:p-2 text-xs sm:text-sm font-semibold font-outfit bg-canvas-secondery bg-opacity-30 rounded whitespace-nowrap shrink-0"
            onClick={handleReset}
          >
            Reset
          </button>
          {dataSource === "online" && dataList.length > 0 && (
            <button
              type="button"
              className="py-1.5 px-2 sm:py-2 sm:px-3 inline-flex items-center gap-x-1.5 sm:gap-x-2 text-xs sm:text-sm font-semibold font-outfit rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white disabled:cursor-progress disabled:opacity-70 whitespace-nowrap shrink-0"
              onClick={handleSaveOffline}
              disabled={isSavingOffline}
            >
              {isSavingOffline ? (
                <ButtonLoader />
              ) : (
                <FiDownload className="w-4 h-4 shrink-0" />
              )}
              <span className="hidden xs:inline">
                {isSavingOffline ? "Downloading..." : "Download"}
              </span>
            </button>
          )}
          {hasOfflineSnapshot && !isSavingOffline && online && (
            <button
              type="button"
              className="py-1.5 px-2 sm:py-2 sm:px-3 inline-flex items-center gap-x-1.5 sm:gap-x-2 text-xs sm:text-sm font-semibold font-outfit rounded-lg border border-gray-200 bg-canvas-danger text-canvas-white whitespace-nowrap shrink-0"
              onClick={handleClearCachedData}
            >
              <FiTrash2 className="w-4 h-4 shrink-0" />
              <span className="hidden xs:inline">Clear cache</span>
            </button>
          )}
        </div>
      </div>
      {/* Selection Message */}
      {isAllCheckActive && (
        <p className="pl-5">
          All {active ? totalRecord : dataList.length} rows on this page are
          selected.
          <button
            onClick={handleClick}
            className="text-canvas-primary font-bold underline"
          >
            &nbsp; {active ? "No " : `Select all ${totalRecord} `}&nbsp;
          </button>
          Select records.
        </p>
      )}
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-canvas-userbar ">
            <tr>
              <th className="md:px-6 px-2 py-2 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                <input
                  type="checkbox"
                  className="tableCheckbox"
                  checked={isAllCheckActive}
                  onChange={handleCheckedAll}
                />
              </th>
              <th className="md:px-6 px-2 py-2 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                <div className="flex gap-1 justify-center items-center">
                  <p>Apt.No.</p>
                  <button onClick={toggleApartmentSortingOrder}>
                    {isApartmentAscending ? (
                      <FaChevronUp className="h-4 w-4" />
                    ) : (
                      <FaChevronDown className="h-4 w-4" />
                    )}
                  </button>
                </div>
              </th>
              <th className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                <div className="flex gap-1 justify-center items-center">
                  <p>Address</p>
                  <button onClick={toggleAddressSortingOrder}>
                    {isAddressAscending ? (
                      <FaChevronUp className="h-4 w-4" />
                    ) : (
                      <FaChevronDown className="h-4 w-4" />
                    )}
                  </button>
                </div>
              </th>
              <th className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                View
              </th>
              <th className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                Associated Contacts
              </th>
              <th className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                Household Disposition
              </th>
              <th className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                <div className="flex gap-1 items-center justify-center">
                  <p>City</p>
                  <button onClick={toggleCitySortingOrder}>
                    {isCityAscending ? (
                      <FaChevronUp className="h-4 w-4" />
                    ) : (
                      <FaChevronDown className="h-4 w-4" />
                    )}
                  </button>
                </div>
              </th>
              <th className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase">
                Map
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-canvas-primary/20">
            {loading ? (
              <TableSkeleton columns={8} />
            ) : (
              (dataSource === "cached" ? cachedDisplayList : dataList).map(
                (ele) => (
                  <tr
                    className="hover:bg-canvas-primary/15 group/row text-canvas-primary transition-all"
                    key={ele.id}
                  >
                    <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-800 text-center">
                      <input
                        type="checkbox"
                        checked={checkedItems.includes(ele.id)}
                        className="tableCheckbox"
                        onChange={() => handleCheckedItem(ele.id)}
                      />
                    </td>
                    <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center transition-all">
                      {ele?.properties?.apt_number || "--"}
                    </td>
                    <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center transition-all">
                      {ele?.properties?.residence_address_line ||
                        ele?.properties?.aristotle_address ||
                        "--"}
                    </td>
                    <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                      {dataSource === "cached" ? (
                        <span title="Editing is unavailable while viewing cached offline data">
                          <MdModeEdit className="w-6 h-6 text-gray-300" />
                        </span>
                      ) : (
                        <button
                          type="button"
                          onClick={() => handleEditClick(ele)}
                        >
                          <MdModeEdit className="w-6 h-6 text-canvas-secondary group-hover/row:text-black transition-all" />
                        </button>
                      )}
                    </td>
                    <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                      <div className="hs-dropdown relative inline-flex">
                        <button
                          className="hs-dropdown-toggle"
                          onClick={() => showAssociateContact(ele?.id)}
                        >
                          <IoIosContacts className="w-7 h-7" />
                        </button>
                        <AssociatedContact
                          dataProperty={dataProperty}
                          isAssociateListLoading={isAssociateListLoading}
                          noAddContact
                          setShowAssociateList={setShowAssociateList}
                          showAssociateContact={showAssociateContact}
                          associatedContact={associatedContact[ele.id]}
                          hiddenFields={contactHiddenFields}
                        />
                      </div>
                    </td>
                    <td
                      className="md:px-6 px-3 py-2 whitespace-nowrap text-sm font-outfit text-center transition-all font-medium"
                      style={{
                        color: ele?.properties?.household_disposition
                          ? getDispositionColor(
                              ele.properties.household_disposition,
                              dispositionColors,
                            )
                          : undefined,
                      }}
                    >
                      {ele?.properties?.household_disposition || "--"}
                    </td>
                    <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center transition-all">
                      {ele?.properties?.residence_city ||
                        ele?.properties?.aristotle_city ||
                        ele?.properties?.mailing_city ||
                        "--"}
                    </td>
                    <td className="md:px-6 px-3 py-2 whitespace-nowrap transition-all text-xs font-outfit underline text-center">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={`https://maps.google.com/?q=${ele?.properties?.residence_address_line || ele?.properties?.aristotle_address}, ${ele?.properties?.mailing_city}, CT, USA`}
                      >
                        {ele?.properties?.residence_address_line ||
                          ele?.properties?.aristotle_address}{" "}
                        {ele?.properties?.mailing_city}
                      </a>
                    </td>
                  </tr>
                ),
              )
            )}
            {!loading &&
              dataSource === "cached" &&
              cachedDisplayList.length === 0 && (
                <tr className="text-center hover:bg-canvas-primary/15 group/row text-canvas-primary transition-all">
                  <td colSpan={8} className="px-6 py-4">
                    No cached data - connect to internet and save data first
                  </td>
                </tr>
              )}
            {!loading &&
              dataSource === "online" &&
              dataList.length === 0 &&
              allDataLoaded && (
                <tr className="text-center hover:bg-canvas-primary/15 group/row text-canvas-primary transition-all">
                  <td colSpan={8} className="px-6 py-4">
                    No households found.
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>

      {/* Load More */}
      {dataSource === "online" &&
        !allDataLoaded &&
        !hideLoading &&
        dataList.length >= 10 &&
        navigator.onLine && (
          <div className="w-full flex items-center justify-center p-5">
            <button
              type="button"
              className="py-2 px-3 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white disabled:cursor-progress"
              onClick={handlePagination}
              disabled={loading}
            >
              {loading ? "Loading..." : "Load More"}
            </button>
          </div>
        )}

      {/* Filter Modal */}
      <div
        id="hs-household-filter-modal"
        className="hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden size-full fixed top-0 start-0 z-[80] opacity-0 overflow-x-hidden transition-all overflow-y-auto pointer-events-none"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all sm:max-w-2xl m-3 sm:mx-auto">
          <div className="flex flex-col bg-canvas-white border shadow-sm rounded-xl pointer-events-auto max-h-[800px]">
            <div className="p-4 overflow-y-auto">
              <h4 className="pb-5 flex justify-center">
                Max. 3 search together allowed.
              </h4>
              <form className="w-full" onSubmit={applyFilters}>
                <ConfigurableFilterFields
                  page="households"
                  dataProperty={dataProperty}
                  bindings={{
                    residence_zip: [searchZip, setSearchZip],
                    census_block: [searchCensus_block, setSearchCensus_block],
                    presence_of_children_code: [searchPresence_of_children_code, setSearchpresence_of_children_code],
                  }}
                  renderers={{
                    residence_address_line: () => (
                      <SearchInputField
                        label="Street Address"
                        onChange={(e) => setSearchAddress([e.target.value])}
                      />
                    ),
                    team: () => (
                      <div className="md:flex md:items-center justify-between w-full mb-6">
                        <div className="md:w-1/3">
                          <label
                            className="block text-gray-500 font-bold mb-1 md:mb-0 pr-4"
                            htmlFor="household-team"
                          >
                            Team
                          </label>
                        </div>
                        <div className="md:w-2/3">
                          <Select
                            inputId="household-team"
                            name="household-team"
                            className="bg-canvas-userbar appearance-none border-none border-canvas-tersery rounded w-full text-gray-700 leading-tight focus:outline-none"
                            options={teamOptions}
                            value={
                              teamOptions.find(
                                (option) => option.value === searchTeam,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setSearchTeam(
                                selectedOption ? selectedOption.value : "",
                              )
                            }
                            isClearable
                          />
                        </div>
                      </div>
                    ),
                    residence_city: () => (
                      <div className="md:flex md:items-center justify-between w-full mb-6">
                        <div className="md:w-1/3">
                          <label
                            className="block text-gray-500 font-bold mb-1 md:mb-0 pr-4"
                            htmlFor="input-field"
                          >
                            City
                          </label>
                        </div>
                        <div className="md:w-2/3">
                          <Select
                            id="city"
                            name="city"
                            className="bg-canvas-userbar appearance-none border-none border-canvas-tersery rounded w-full text-gray-700 leading-tight focus:outline-none"
                            options={allCityOptions}
                            value={
                              allCityOptions.find(
                                (option) => option.value === searchCity,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setSearchCity(
                                selectedOption ? selectedOption.value : null,
                              )
                            }
                            isClearable
                          />
                        </div>
                      </div>
                    ),
                  }}
                  customValues={customFilterValues}
                  onCustomChange={(key, value) =>
                    setCustomFilterValues((prev) => ({ ...prev, [key]: value }))
                  }
                />
                <SearchInputField
                  label="List Membership"
                  onChange={(e) => setSelectedMemberList(e.target.value)}
                  type="select"
                  options={listMemberData}
                />
                <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                  <button
                    type="submit"
                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white"
                    data-hs-overlay="#hs-household-filter-modal"
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* City Tag Filter Modal */}
      <div
        id="hs-household-city-modal"
        className="hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden size-full fixed top-0 start-0 z-[80] opacity-0 overflow-x-hidden transition-all overflow-y-auto pointer-events-none"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all sm:max-w-2xl m-3 sm:mx-auto">
          <div className="flex flex-col bg-canvas-white border shadow-sm rounded-xl pointer-events-auto max-h-[800px]">
            <div className="p-4 overflow-y-auto">
              <h4 className="pb-5 flex justify-center">
                Max. 3 city search allowed.
              </h4>
              <form className="w-full" onSubmit={(e) => applyFilters(e)}>
                <TagInput
                  label={"Street Address"}
                  value={searchCityTags}
                  setValue={setSearchCityTags}
                />
                <div className="flex justify-center items-center gap-x-2 py-3 px-4 dark:border-gray-700">
                  <button
                    type="submit"
                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white"
                    data-hs-overlay="#hs-household-city-modal"
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Assign Canvasser Modal */}
      <div
        id="hs-household-assign-modal"
        className="hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden size-full fixed top-0 start-0 z-[80] opacity-0 overflow-x-hidden transition-all overflow-y-auto pointer-events-none"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all sm:max-w-xl sm:w-full m-3 sm:mx-auto">
          <div className="flex flex-col bg-canvas-white border shadow-sm rounded-xl pointer-events-auto">
            <div className="p-4 overflow-y-auto">
              <form className="w-full" onSubmit={handleAssignedSubmit}>
                <div className="flex flex-col gap-3 mb-6">
                  <label
                    className="text-gray-500 font-bold"
                    htmlFor="household-owner-select"
                  >
                    Canvasser Owner
                  </label>
                  <div className="w-full">
                    <select
                      className="bg-canvas-userbar appearance-none border-2 border-canvas-tersery rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-canvas-white focus:border-purple-500"
                      id="household-owner-select"
                      value={selectedUser.email}
                      onChange={handleUserSelect}
                    >
                      <option value="">Select an Owner</option>
                      {ownerList.filter((user) => user.isActive !== false).map((user) => (
                        <option
                          key={user.id}
                          value={user.email}
                          data-id={user.id}
                        >
                          {user.firstName}&nbsp;{user.lastName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="flex flex-col gap-3 mb-6">
                  <label
                    className="text-gray-500 font-bold"
                    htmlFor="household-tcp-owner-select"
                  >
                    TCP Canvasser Owner
                  </label>
                  <div className="w-full">
                    <select
                      className="bg-canvas-userbar appearance-none border-2 border-canvas-tersery rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-canvas-white focus:border-purple-500"
                      id="household-tcp-owner-select"
                      value={selectedUser2.email}
                      onChange={handleUser2Select}
                    >
                      <option value="">Select a TCP Canvasser Owner</option>
                      {ownerList.filter((user) => user.isActive !== false).map((user) => (
                        <option
                          key={user.id}
                          value={user.email}
                          data-id={user.id}
                        >
                          {user.firstName}&nbsp;{user.lastName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <span className="text-red-500">
                    {assignError ? "At least select one Owner" : ""}
                  </span>
                </div>
                <div className="flex justify-end items-center gap-x-2">
                  <button
                    type="submit"
                    disabled={assignLoading}
                    className="py-3 px-6 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white"
                  >
                    {assignLoading && <ButtonLoader />}
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Household Modal */}
      {userId && (
        <Dialog
          open={modalIsOpen}
          onClose={closeModal}
          className="relative z-50"
        >
          <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-canvas-primary/60 backdrop-blur-sm">
            <div
              className="absolute top-0 left-0 w-full h-screen z-10"
              onClick={closeModal}
            />
            <div className="xl:max-w-6xl lg:max-w-5xl md:max-w-4xl max-w-4xl sm:w-full sm:mx-auto bg bg-canvas-white border rounded-xl pointer-events-auto max-h-[calc(100vh-3.5rem)] overflow-y-auto z-[99]">
              <div className="p-4 sm:p-6 md:p-8">
                <h2 className="font-bold uppercase flex justify-center mb-4">
                  Household Details
                </h2>
                <form onSubmit={handleSubmit} noValidate>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("household_disposition")) && (
                      <EditInputField
                        label="Household Disposition"
                        name="houseHoldDisposition"
                        value={houseHoldDisposition}
                        onChange={(e) => setHouseHoldDisposition(e.target.value)}
                        type="select"
                        options={getDispositionOptions(dataProperty)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("canvassing_language_barrier")) && (
                      <EditInputField
                        label="Canvassing Language Barrier"
                        name="canvassing_language_barrier"
                        value={canvassingLanguageBarrier}
                        onChange={(e) =>
                          setCanvassingLanguageBarrier(e.target.value)
                        }
                        type="select"
                        options={CANVASSING_LANGUAGE_BARRIER_OPTIONS}
                      />
                    )}

                    <EditInputField
                      label="Last Door Knocked by"
                      name="last_door_knocked_by"
                      value={last_door_knocked_by}
                      onChange={(e) => set_last_door_knocked_by(e.target.value)}
                      type="select"
                      options={userList?.map((item) => ({
                        value: item.id,
                        label: `${item.firstName} ${item.lastName}`,
                      }))}
                      disabled
                    />
                    <EditInputField
                      label="Last Door Knocked Date"
                      name="last_door_knocked"
                      value={last_door_knocked}
                      onChange={(e) => set_last_door_knocked(e)}
                      type="date"
                      disabled
                    />
                    <EditInputField
                      label="Attempt Tracker"
                      name="attempt_tracker"
                      value={attempt_tracker}
                      disabled
                    />
                    <EditInputField
                      label="Household Attempted"
                      name="household_attempted_"
                      value={household_attempted_}
                      onChange={(e) => handleHouseholdAttempt(e)}
                      type="checkbox"
                    />
                  </div>

                  <DndProvider backend={HTML5Backend}>
                    <div className="hs-accordion-group w-full gap-4 mt-5">
                      <DraggableAccordion
                        key={householdAccordionFields.map((f) => f.name).join(",")}
                        accordionData={householdAccordionData}
                        formState={householdAccordionFormState}
                        formFields={householdAccordionFields}
                        setFormState={() => {}}
                        handleInputChange={handleAccordionInputChange}
                        dataProperty={dataProperty}
                      />
                    </div>
                  </DndProvider>
                  <div className="flex items-center justify-between gap-5 mt-5">
                    <div className="flex items-center gap-5">
                      <button
                        type="submit"
                        disabled={isSubmitLoading}
                        className="shadow bg-canvas-primary text-white font-bold py-2 px-6 rounded flex items-center gap-3"
                      >
                        {isSubmitLoading && <ButtonLoader />}
                        Save
                      </button>
                      <button
                        className="bg-gray-200 py-2 px-6 rounded"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="hs-dropdown relative inline-flex">
                      <button
                        type="button"
                        className="hs-dropdown-toggle font-semibold flex items-center gap-5"
                        onClick={() => showAssociateContact(userId)}
                      >
                        ASSOCIATED CONTACTS{" "}
                        <IoIosContacts className="w-7 h-7" />
                      </button>
                      <AssociatedContact
                        isModel
                        dataProperty={dataProperty}
                        isAssociateListLoading={isAssociateListLoading}
                        setShowAssociateList={setShowAssociateList}
                        showAssociateContact={showAssociateContact}
                        associatedContact={associatedContact[userId]}
                        hiddenFields={contactHiddenFields}
                        addContactModalData={{
                          l2Id,
                          mailing_city,
                          residence_state,
                          residence_zip,
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default HouseholdsComponent;
